var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profile-page"},[_c('div',{staticClass:"profile-page__menu"},[_vm._t("pagemenu")],2),_c('div',{staticClass:"profile-page__content"},[_vm._t("pagecontent")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }